import styled from 'styled-components';
import colors from '../../styles/colors';

export const Container = styled.div`
  background-color: ${colors.dark3};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  width: 100%;
  min-height: fit-content;
`;

export const Content = styled.div`
  background-color: ${colors.dark3};
  width: 100%;
  max-width: 1100px;
  padding: 0 10px;
  color: ${colors.white};
  font-size: 15px;
  .footer-address {
    border-bottom: 1px solid ${colors.white};
    padding-bottom: 5px;
    width: 100%;
    ul {
      padding: 0;
      margin: 0;
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      justify-content: center;
      li {
        display: flex;
        align-items: center;
        padding: 0 15px 5px 0;
        &:last-child {
          padding-right: 0;
        }
        svg {
          font-size: 18px;
          margin-right: 5px;
          min-width: 20px;
          min-height: 20px;
        }
        span {
          text-align: center;
        }
      }
    }
  }
  .footer-copy {
    margin-top: 10px;
    width: 100%;
    text-align: center;
  }
`;
